module.exports = __webpack_public_path__ + "static/interaction-1-4-c7e331cd563029dca53130181c94d477.png";